import { FC } from 'react'

import { useWallet } from '@aptos-labs/wallet-adapter-react'
import { useDisclosure } from '@mantine/hooks'

import { ButtonConnectWallet } from 'components/ButtonConnectWallet'
import { ButtonInfoAccount } from 'components/ButtonInfoAccount'
import { WalletList } from 'components/WalletList'
import { useCommonConnectStore } from 'components/WalletProvider/store'

const ConnectButton: FC = () => {
  const { connected } = useWallet()
  const [opened, { close, open }] = useDisclosure(false)
  const claimWidgetClasses = useCommonConnectStore((state) => state.claimWidgetClasses)

  return (
    <>
      {!connected && <ButtonConnectWallet className={claimWidgetClasses.connectWalletButton} onClick={open} />}
      {connected && <ButtonInfoAccount disconnectButtonClassName={claimWidgetClasses.connectWalletButton} />}
      <WalletList centered onClose={close} opened={opened} />
    </>
  )
}

export default ConnectButton
